import type { Match } from '../../types';

export type StatsMatch = Omit<Match, 'duration'> & {
  duration: number | null;
  team?: 'CT' | 'T';
  kills?: number;
  deaths?: number;
  assists?: number;
  playerScore?: number;
};

export function matchOutcome(m: StatsMatch): 'win' | 'loss' | 'draw' | 'pending' {
  if (m.status !== 'finished') return 'pending';
  if (m.score[0] === m.score[1]) return 'draw';
  const ctWon = m.score[0] > m.score[1];
  if (m.team === 'CT') return ctWon ? 'win' : 'loss';
  if (m.team === 'T') return ctWon ? 'loss' : 'win';
  return ctWon ? 'win' : 'loss';
}

export function formatChartDate(iso: string, locale: string = 'ru-RU'): string {
  const d = new Date(iso.includes('T') ? iso : `${iso}T12:00:00`);
  return d.toLocaleDateString(locale, { day: '2-digit', month: 'short' });
}

export function displayMapName(map: string): string {
  return map
    .replace(/^de_/i, '')
    .replace(/_/g, ' ')
    .replace(/\b\w/g, (c) => c.toUpperCase());
}
